'use strict';

module.exports = function (data) {
  this.data = this.applyFilters(data.data);
  this.count = parseInt(data.count);

  setTimeout(function () {
    this.dispatch('loaded', data);
  }.bind(this), 0);
};


// WEBPACK FOOTER //
// ./src/components/vuetable-2-kernel/compiled/methods/set-data.js